module.exports = __webpack_public_path__ + "static/tikka-7aacb731baed6f54656620146f4c63fd.png";